"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Dropdown_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Dropdown"));
var react_1 = require("react");
var Item_1 = __importDefault(require("../Item/Item"));
var IconItem_1 = __importDefault(require("../IconItem/IconItem"));
var DropItem_1 = __importDefault(require("../DropItem/DropItem"));
var ProfileDropItem_1 = __importDefault(require("./ProfileDropItem/ProfileDropItem"));
var ProfileIcon_1 = __importDefault(require("../ProfileIcon/ProfileIcon"));
var main_1 = require("../../../main");
var Search_1 = __importDefault(require("../Search/Search"));
var ResponsiveMenu = /** @class */ (function (_super) {
    __extends(ResponsiveMenu, _super);
    function ResponsiveMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderNavDropItems = function () {
            var navItems = _this.props.navItems;
            return navItems.map(function (child, index) {
                var c = child;
                var item;
                if (typeof child === 'object' && (child.type === Item_1.default || child.type === IconItem_1.default)) {
                    var _a = c.props, key = _a.key, cleanedProps = __rest(_a, ["key"]);
                    item = React.createElement(DropItem_1.default, __assign({ isBadged: child.type === IconItem_1.default }, cleanedProps, { key: index + 'p' }));
                }
                else if (typeof child === 'object' && (child.type !== Search_1.default)) {
                    item = child;
                }
                return item;
            });
        };
        _this.renderProfileDropItems = function () {
            var items = null;
            var profile = _this.props.profile;
            if (profile && profile.props.children) {
                items = profile.props.children;
            }
            return items;
        };
        _this.renderProfileItem = function () {
            var profile = _this.props.profile;
            var profileItem = null;
            if (profile) {
                profileItem = React.createElement(ProfileDropItem_1.default, __assign({}, profile.props));
            }
            return profileItem;
        };
        _this.renderTrigger = function () {
            var trigger;
            if (!_this.props.navItems.length && _this.props.profile) {
                var profile = _this.props.profile;
                trigger = React.createElement("div", { className: "trigger-icon" },
                    React.createElement(ProfileIcon_1.default, { firstName: profile.props.firstName, lastName: profile.props.lastName, imageUrl: profile.props.imageUrl }));
            }
            else {
                trigger = React.createElement(main_1.Icon, { root: "common", name: "ellipsis-vertical", className: "icon button-icon", size: "medium", description: "Toggle Menu" });
            }
            return trigger;
        };
        return _this;
    }
    ResponsiveMenu.prototype.render = function () {
        return (React.createElement(Dropdown_1.default, { className: "icon-menu", item: true, simple: true, direction: "right", icon: "", trigger: this.renderTrigger() },
            React.createElement(Dropdown_1.default.Menu, null,
                this.renderProfileItem(),
                this.renderNavDropItems(),
                this.renderProfileDropItems())));
    };
    return ResponsiveMenu;
}(react_1.Component));
exports.default = ResponsiveMenu;
